import StatementTieringAndFeeStructure from './StatementTieringAndFeeStructure';

export default StatementTieringAndFeeStructure;
